export const LIABILITY_TYPE_CODES = {
  ALIMONY: 0,
  AUTO_LEASE_PAYMENT: 1,
  CHILD_CARE: 2,
  CHILD_SUPPORT: 3,
  HELOC: 4,
  HERO_PACE_LIEN: 16,
  INSTALLMENT: 5,
  OPEN: 6,
  OTHER_JOB_EXPENSE: 7,
  OTHER_LIABILITY: 8,
  REAL_ESTATE: 9,
  REVOLVING: 10,
  SEPARATE_MAINTENANCE: 11,
  STUDENT_LOAN: 15,
  UNION_DUES: 12,
};

export const EXCLUSION_REASON_CODES = {
  COSIGNED_LOAN: 1,
  COURT_ORDERED: 2,
  DEFERRED: 3,
  DUPLICATE: 4,
  LESS_THAN_10_MONTHS_REMAIN: 5,
  NONE: 0,
  NOT_THE_BORROWERS: 6,
  PAID_BY_OTHERS: 8,
  PAID_BY_THE_EMPLOYERS: 7,
  PAID_IN_FULL: 9,
  PROPERTY_BUYOUT: 10,
  SECURED: 11,
  TO_BE_PAID: 12,
};

export const MATCH_TYPE = {
  AUTO_MATCH: 1,
  MANUAL_MATCH: 2,
  NO_MATCH: 3,
  AI_MATCH: 6,
  I_DO_NOT_KNOW: 5,
  NOT_SELECTED: null,
};

export const LIABILITIES_ASSOCIATION_I_DONOT_KNOW = `I don't know`;

export const LIABILITIES_ASSOCIATION_ALERT = `A mortgage liability is missing association to a property. Provide documentation that indicates the property address linked to the following accounts:`;
